var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#6019E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.56 36L36.73 34.83C38.54 33.02 41 32 43.57 32H53.13C57.54 32 61.12 35.58 61.12 39.99C61.12 44.42 57.54 48 53.12 48H25.56V44H53.12C55.33 44 57.12 42.21 57.12 40C57.12 37.79 55.33 36 53.12 36H35.56ZM18 36C15.79 36 14 34.21 14 32C14 29.79 15.79 28 18 28H45.56V24H18C13.58 24 10 27.58 10 32C10 36.42 13.58 40 18 40H27.55C30.11 40 32.57 38.98 34.39 37.17L35.56 36H18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStitch);
export default __webpack_public_path__ + "static/media/icon-stitch.4166637940e1d2aad575c5fabd730bd1.svg";
export { ForwardRef as ReactComponent };